import { trpc } from '@/shared/api/trpc';

const FIVE_MINUTES = 5 * 60 * 1000;

/**
 * XT-708 — the operation statuses the org's process allows from a service's
 * current one. `statusIds: null` means the process says nothing about that
 * status, so nothing is filtered out.
 *
 * The twin of `useAllowedStatusTargets` on the itinerary side, and it exists
 * for the same reason: the write path enforces the process
 * (`assertTransitionAllowed`), so any control that offers a status has to ask
 * the SAME resolver first. Otherwise the dropdown and the advance button offer
 * moves the server then rejects.
 */
export const useAllowedOperationTargets = (fromStatusId: string | null) =>
  trpc.operationStatusMachine.allowedTargets.useQuery(
    { fromStatusId: fromStatusId ?? '' },
    {
      enabled: Boolean(fromStatusId),
      // The process changes rarely; the dropdown opens often.
      staleTime: FIVE_MINUTES,
    }
  );
